import { render, staticRenderFns } from "./OnboardingAepps.vue?vue&type=template&id=62b7f906&scoped=true"
import script from "./OnboardingAepps.vue?vue&type=script&lang=js"
export * from "./OnboardingAepps.vue?vue&type=script&lang=js"
import style0 from "./OnboardingPage.scss?vue&type=style&index=0&id=62b7f906&prod&lang=scss&scoped=true&external"
import style1 from "./OnboardingAepps.vue?vue&type=style&index=1&id=62b7f906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b7f906",
  null
  
)

export default component.exports